export default __webpack_public_path__ + "static/media/Trend10.375a3437.svg";